<style lang="scss" scoped="">
	.mytable {
		margin-top: 10px;
		font-size: 12px;
		text-align: center;
		border:none !important;
		//#606672
	}
	.mytable /deep/ table{
		border-collapse:collapse;
	}
	.mytable /deep/ table tbody tr:first-child{
		height: 42px;
		font-size: 12px;
	}
	.mytable /deep/ table tbody tr:not(:first-child){
		height: 26px;
		font-size: 12px;
	}
</style>

<template>
	<div ref="container" style="overflow: auto;position: relative">
		<div style="display: flex;justify-content: space-between;margin-top: 26px;">
			<div>
				<p style="color: #C0C4CC;font-size: 14px;">{{$t('shebeimingcheng')}}</p>
				<p style="color: #FFFFFF;font-size: 24px;margin-top: 4px;">{{equipment.name}}</p>
			</div>
			<div>
				<p style="color: #C0C4CC;font-size: 14px;">{{$t('shebeixinghao')}}</p>
				<p style="color: #FFFFFF;font-size: 24px;margin-top: 4px;">{{equipment.modelCode}}</p>
			</div>
			<div>
				<p style="color: #C0C4CC;font-size: 14px;">{{$t('shebeiSN')}}</p>
				<p style="color: #FFFFFF;font-size: 24px;margin-top: 4px;">{{equipment.sn}}</p>
			</div>
			<div>
				<p style="color: #C0C4CC;font-size: 14px;">{{$t('chuchangriqi')}}</p>
				
				<p  style="color: #FFFFFF;font-size: 24px;margin-top: 4px;">{{equipment.leaveFactoryDate?(dayjs.unix(equipment.leaveFactoryDate/1000).format('YYYY-MM-DD')):'-'}}</p>
			</div>
			<div>
			</div>
		</div>
	</div>

</template>
<script type="text/javascript">
	export default {
		name: 'web_monitor_equipment_statistics_tabs_info',
		components: {

		},
		props: {
			equipment: {
				type: Object,
				default: function() {
					return {}
				},
			},
			tabsData: {
				type: Object,
				default: function() {
					return {}
				},
			},
		},
		data() {
			return {

			};
		},
		computed: {
			// current() {
			// 	return this.data 
			// }
		},
		created() {},
		mounted() {
			this.resize()
			this.utils.event_hub.$on('RESIZE', () => {
				this.resize();
			});
		},
		destroyed() {},
		methods: {
			resize() {
				//因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
				setTimeout(() => {

				}, 500)
			},

		}
	};
</script>
